import React, { createContext, useContext } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { APIClient } from './client';

// Create context for the API client
const APIClientContext = createContext<APIClient | null>(null);

// Export context for use in hook
export { APIClientContext };

// Provider component
interface APIClientProviderProps {
  children: React.ReactNode;
}

export const APIClientProvider = ({ children }: APIClientProviderProps) => {
  const { getToken } = useAuth();
  // Create API client with async token getter
  const apiClient = React.useMemo(() => {
    return new APIClient(getToken);
  }, [getToken]);

  return (
    <APIClientContext.Provider value={apiClient}>
      {children}
    </APIClientContext.Provider>
  );
};